import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect, useRef } from 'react';
import useMonitorAPIService from '../../services/monitorapiservice';
import { Switch } from "devextreme-react";
import Toastr from '../utils/toastr';

function AgentChannels(props) {

    const { t } = useTranslation();

    const { changeChannelStatus } = useMonitorAPIService();
    const [channels, setChannels] = useState([]);
    const toastrRef = useRef(null);

    useEffect(() => {
        let channels = [];

        Object.keys(props.agent.channels).map(v => {
            channels.push({
                channel: v,
                value: props.agent.channels[v]
            });
            return null;
        });

        setChannels(channels);
        return () => {
            // component unmounts
        };
    }, [props.agent]);

    const channelChange = (channel, value) => {
        let data = {
            channel: channel,
            value: value,
            userId: props.agent.userId
        };
        setChannels(prevState =>
            prevState.map(c =>
                c.channel === channel ? { ...c, value: value } : c
            )
        );
        changeChannelStatus(props.token, data, (res) => {
            if (res.data) {
                toastrRef.current.setType("success");
                toastrRef.current.setMessage(t("dataupdated"));
                toastrRef.current.show();

            } else {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
                setChannels(prevState =>
                    prevState.map(c =>
                        c.channel === channel ? { ...c, value: !value } : c
                    )
                );
            }
        });
    };
    
    return (
        <div className={"card card-flush overflow-hidden"} >
            <div className="card-header ">
                <h3 className="card-title align-items-start flex-column text-primary">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("chart-network")} /> {t("channels")}</span>

                </h3>
                <div className="card-toolbar">
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem", "height": "300px", "overflow": "auto" }}>
                <Row>
                    <Col> <span className="fs-4 fw-bold text-primary my-2">{t("channel")}</span></Col>
                    <Col> <span className="fs-4 fw-bold text-primary m-2">{t("enabled")}</span></Col>
                </Row>

                {
                    channels.map(v => {
                        return (
                            <Row key={v.channel}>
                                <Col > <span className="fs-5 fw-bold text-gray-800 ">{t(v.channel.toLowerCase())}</span></Col>
                                <Col>
                                    <Switch className='m-1' disabled={!props.functions.channels} switchedOnText={t("yes")} switchedOffText={t("no")} value={v.value} onValueChange={value => { channelChange(v.channel, value) }} text />
                                </Col>
                            </Row>
                        )
                    })
                }
            </div>
            <Toastr ref={toastrRef} />
        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        functions: state.supervisor.functions
    };
};

export default connect(mapStateToProps, {})(AgentChannels);